import { theme as antdTheme, type ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  cssVar: true,
  token: {
    colorPrimary: "#3b82f6",
    colorBgBase: "#0e0f12",
    colorBgContainer: "#1d1f24",
    colorBgElevated: "#262932",
    colorBgLayout: "#0e0f12",
    colorBorder: "#2a2c33",
    colorBorderSecondary: "#1f2125",
    colorText: "rgba(255, 255, 255, 0.92)",
    colorTextSecondary: "rgba(255, 255, 255, 0.65)",
    colorTextTertiary: "rgba(255, 255, 255, 0.45)",
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
    controlHeight: 36,
  },
  components: {
    Layout: {
      headerBg: "transparent",
      bodyBg: "transparent",
      siderBg: "transparent",
      headerHeight: 60,
      headerPadding: "0 20px",
    },
    Menu: {
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#1d1f24",
    },
    Card: {
      colorBgContainer: "#1d1f24",
      borderRadiusLG: 8,
    },
    Modal: {
      contentBg: "#1d1f24",
      headerBg: "#1d1f24",
      borderRadiusLG: 8,
    },
    Button: {
      borderRadius: 4,
      controlHeight: 36,
      fontWeight: 500,
    },
    Input: {
      controlHeight: 38,
      borderRadius: 6,
    },
  },
};

export const CDN_URL = "https://d1wumrtbuo797i.cloudfront.net/";
export const DOWNLOAD_URL = "https://texture-ninja.nyc3.cdn.digitaloceanspaces.com/";
